import { connect } from 'react-redux'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import TraySize from '../detail/TraySize'


const mapStateToProps = (state, props) => {
    return {
        customer: selector.selectCustomer(state),
    }
}

const mapDispatchToProps = {
    changeCustomer: action.changeCustomer,
    saveCustomer: action.saveCustomer,
}

export default connect(mapStateToProps, mapDispatchToProps)(TraySize)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/TraySizeWidgetContainer.js